import { EftFundingTransaction, TransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchEFTFundTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);
  const [eftFundTransaction, setEftFundTransaction] = useState<EftFundingTransaction>();

  async function fetchEftFundTransaction(params: TransactionRequest) {
    try {
      setFetching(true);
      const res = await api.fetchEFTFundTransaction(params, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setEftFundTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  function resetEftFundTransaction() {
    setEftFundTransaction(undefined);
  }

  return { fetching, eftFundTransaction, fetchEftFundTransaction, resetEftFundTransaction };
}
